import React from 'react';

// Lightweight SVG fallback to avoid importing from react-icons/fi here
// This prevents every component that imports SafeIcon from triggering a massive icon bundle load
const AlertIcon = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

const SafeIcon = ({ icon, ...props }) => {
  if (typeof icon === 'function') {
    return React.createElement(icon, props);
  }
  return <AlertIcon {...props} />;
};

export default SafeIcon;